import { AudienceFile } from '@/common/models';
import ErrorHandler from '@/ErrorHandler';
import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';
import API from '@/org-app/api';
import {
  createApiAction,
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPutAction,
} from '@/utils/ActionsUtils';
import i18n from '@/vueI18n';

import * as types from './mutation-types';

export default {
  createNewAudienceFile(
    { commit },
    audienceFile = AudienceFile.fromObject({
      id: -1,
    }),
  ) {
    commit(types.CREATE_AUDIENCEFILE, audienceFile);
    return audienceFile;
  },
  getAudienceFiles: createGetAllAction(
    API.instance.getAudienceFiles,
    types.UPDATE_AUDIENCEFILES_LIST,
    'messages.failedToGetAudienceFiles',
    true,
    null,
  ),
  getAudienceFile: createGetOneAction(
    API.instance.getAudienceFile,
    types.UPDATE_AUDIENCEFILE,
    'messages.failedToGetAudienceFile',
  ),
  updateAudienceFile: createPutAction(
    API.instance.putAudienceFile,
    types.SAVE_AUDIENCEFILES,
    'messages.failedToUpdateAudienceFile',
  ),
  deleteAudienceFile: createDeleteAction(
    API.instance.deleteAudienceFile,
    types.DELETE_AUDIENCEFILE,
    'messages.failedToDeleteAudienceFile',
  ),

  saveAudienceFile: createApiAction(
    API.instance.uploadAudienceFiles,
    types.SAVE_AUDIENCEFILES,
    'messages.failedToCreateAudienceFile',
  ),

  async uploadAudienceFile({ commit }, { demographicID, file }) {
    GlobalEventBus.$emit(GlobalEvents.loading);
    try {
      const result = await API.instance.uploadAudienceFile({ demographicID, file });
      return result;
    } catch (e) {
      const msg = i18n.global.t('messages.failedToSaveCreative');
      ErrorHandler.showError(msg, e);
    } finally {
      GlobalEventBus.$emit(GlobalEvents.loaded);
    }
  },
};
